import { get } from "lodash"
import * as React from "react"
import { Input, InputProps } from "."
import { sanitizeEmailInput } from "utils/emailValidation"

type Props = InputProps

const EmailInput = (props: Props) => {
  const { formik, name, onChange, onBlur, value: valueProp, ...rest } = props

  const formikValue =
    name && formik ? (get(formik.values, name) as string | undefined) : undefined
  const value = valueProp ?? formikValue ?? ""

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const sanitized = sanitizeEmailInput(e.target.value)

    if (formik && name) {
      void formik.setFieldValue(name, sanitized, true)
    }

    onChange?.({
      ...e,
      target: { ...e.target, value: sanitized },
    } as React.ChangeEvent<HTMLInputElement>)
  }

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    formik?.handleBlur(e)

    if (formik && name) {
      void formik.validateField(name)
    }

    onBlur?.(e)
  }

  return (
    // @ts-ignore ref typing from forwardRef wrapper
    <Input
      type="email"
      inputMode="email"
      autoComplete="email"
      {...rest}
      name={name}
      formik={formik}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  )
}

export default EmailInput
